import React from "react"

export default function Footer(props) {
  return (
    <div className="links footer">
      <h3 className="main-button" id="search" onClick={props.onClick}>Search</h3>
      <h3 className="main-button" id="author"><a href="http://www.edbertcheng.com/" rel="noreferer noopener" target="_blank">edberto</a></h3>
    </div>
  );
}
